const initialState = {
    formInfo: {
        status: 'NEW' , 
        transactionID: '' , 
        mode: 'NEW' , 
        action: 'CREATE' , 
        created:'',
        withUpdates: false
    },
    formType: {
        form: '',
        type: '',
        fields:[],
        sections:[],
    },
    formTemplatesList: [],
    // formsTemplates: [],
    loading: true,
    selectedTemplates: [],
    sharedForms: [],
    supportingDocuments: [],
    error: {show: false, errorMessage:''},
    formState: {mainValues: {} },
    // formState: {mainValues: {} , formValues: [] , validated: false },
    formErrors: {mainValues: {} , formValues: []},
    alert: {show: false, title: "" , body: "" , btnLabel:"OK", btnFunc: null , showBtn: true},
    formSignatories: [],
    userDetails: {},
    agentDetails: {},
    partiesFieldsCount: { //minimum of 4 parties
        buyer: 1,
        seller: 1,
        purchaser: 1,
        vendors: 1,
        landlord: 1,
        tenant: 1
    },
    agentNames: []
} 

export default initialState;